import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";

import deleteContactIcon from "../assets/deleteContactIcon.svg"
import CardContacto from "./CardContacto";
import DetailContact from './DetailContact';
import { useWindowWidth } from "@react-hook/window-size";
import AgregarContacto from "./AgregarContacto.jsx"
import Swal from "sweetalert2";
import { getAllsContactsPagination, updateContactById, getContactByID } from "../../endpoints"
import test from "../assets/Animacion-nosotros.webm"
import { useParams } from "react-router-dom";
import CustomCircularProgress from "../../Components/Loading/CustomCircularProgress.jsx"
import iconAdd from "./iconAdd.svg"
import { 
  ButtonAux,
  VideoCont,
  DivBoxContainer,
  DivContentFilters,
  ItemAux,
  DivFlexColumn,
  IconButton,
  Input,
  ContainerBox,
  DivRow,
  DivRow1,
  ScrollContainer,
  Text,
  Text1
} from "./stylesContacts.js"



const Contacts = ({ user }) => {
  const [contacts, setContacts] = useState([]);
  const [contactsFilter, setContactsFilter] = useState([]);
  const [seActualizoContacto, setSeActualizoContacto] = useState(false);
  const params = useParams();
  const onlyWidth = useWindowWidth();
  const navigate = useNavigate()
  const [openModalObservaciones, setOpenModalObservaciones] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [buscador, setBuscador] = useState(null);
  const [oldBuscador, setOldBuscador] = useState();
  const scrollContainerRef = useRef(null);
  const [openAddContact, setOpenAddContact] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedContact, setSelectContact] = useState();
  const [idContact, setIdContact] = useState();
  const [totalcontactViewer, setTotalcontactViewer] = useState();
  const [statusContact, setStatusContact] = useState('No Contactado');
  const [refresh, setRefresh] = useState();
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    telefono: '',
    email: '',
    ramo: '',
    asesorAsignado: '',
  });


  const getContactID = async (id) => {
    getContactByID(id).then((response) => {
      if (response.status === 200) {
        setSelectContact(response.data)
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      } else {
        console.log(response)
        setLoading(false)

      }
    })
  }

  useEffect(() => {
    if (idContact) {
      setLoading(true)
      getContactID(idContact)
    }
    if (params.id) {
      setLoading(true)
      getContactID(params.id)
    }

  }, [idContact, params]);


  useEffect(() => {
    localStorage.removeItem("observacion")
    localStorage.removeItem("viaDeContacto")
    localStorage.removeItem("statusContact")
    localStorage.removeItem("selectedDate")
  }, [params])


  const handleNextPage = (currentPage, totalPages) => {
    if (currentPage < totalPages) {
      let auxCurrent = currentPage + 1;
      setCurrentPage(auxCurrent);
    } else {
    }
  };

  const getContacts = async (buscador, curretPageAux) => {
    setLoading2(true);
    getAllsContactsPagination({
      page: curretPageAux ? curretPageAux : currentPage,
      perPage: buscador !== null && buscador !== "" ? 99999999 : 30,
      filterBy: buscador,
      userId: user.id,
      status: statusContact,
      userType: user.type
    }).then((response) => {
      if (response?.status === 200) {
        if (buscador !== null && buscador !== "") {
          const newContacts = [...contacts, ...response.data.contacts];
          setContactsFilter(response.data.contacts)
          setTotalcontactViewer(response.data.total)
          setTotalPages(1);
          setLoading2(false)
        }
        else {
          if (curretPageAux) {
            setCurrentPage(1)
          }
          const newContacts = [...contacts, ...response.data.contacts];
          setContacts(newContacts);
          setTotalcontactViewer(response.data.total)
          setTotalPages(Math.ceil(response.data.total / 30)); // Suponiendo que tienes la información del total de contactos
          setLoading2(false)
        }
      } else {
        setLoading2(false)
      }
    });
  };

  useEffect(() => {
    setLoading2(true)
    getContacts(buscador)
  }, [currentPage, buscador, refresh]);

  useEffect(() => {
    setLoading2(true)
    getContacts(buscador, 1)
  }, [refresh]);

  useEffect(() => {
    setContacts([])
    setRefresh(statusContact)
  }, [statusContact])

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    const handleScroll = () => {
      if (scrollContainer.scrollHeight - parseInt(scrollContainer.scrollTop) === scrollContainer.clientHeight) {
        handleNextPage(currentPage, totalPages);
      }
    };
    scrollContainer.addEventListener('scroll', handleScroll);
    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [currentPage, buscador, scrollContainerRef.current, totalPages]);


  const handlerOpenModal = () => {
    setOpenModal(true);
  }

  const handlerOpenModalObservaciones = () => {
    setOpenModalObservaciones(true);
  }

  const closeModalObservaciones = () => {
    setOpenModalObservaciones(false);
  }

  const closeModal = () => {
    setOpenModal(false);
  }

  const navigateAddContactBtn = () => {
    if (onlyWidth > 800) {
      setOpenAddContact(true);
    } else {
      navigate('/add-contacts');
    }
  }

  const navigateDeleteContactBtn = () => {
    if (selectedContact?.id) {
      Swal.fire({
        title: "¿Está seguro que desea eliminar este contacto?",
        text: "Tenga en cuenta que ya no podrá acceder a toda la informacion asociada a este contacto.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#003049",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            icon: "success",
            title: "El contacto fue eliminado",
            confirmButtonText: "Listo",
            confirmButtonColor: "#003049",
          });
          console.log("SE ELIMINO EL CONTACTO")
        }
      });
    }

  }

  const handleChangeBuscador = (e) => {
    const { name, value } = e.target;
    setCurrentPage(1)
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
    setBuscador(value);
  };

  return (
    <ContainerBox >
      <DivContentFilters params={params}>
        <DivRow>
          <Text1>{`Total: ${totalcontactViewer ? totalcontactViewer : 0}`}</Text1>
       
          
              <DivRow1>
                <ButtonAux
                  onClick={(e) => navigateAddContactBtn(e)}>
                  <IconButton
                    src={iconAdd}

                  />
                  Crear Contacto
                </ButtonAux>
                {/* <ButtonAux
                  onClick={() => navigateDeleteContactBtn()}
                  style={{
                    opacity: !selectedContact && !selectedContact?.name ? 0.1 : 1
                  }}
                >
                  <IconButton src={deleteContactIcon}/>
                  Eliminar
                </ButtonAux> */}
              </DivRow1>
          
        </DivRow>
        <DivRow1>
          <ItemAux style={{
            color: 'black',
            borderRadius: "8px",
            border: statusContact === "" ? "solid 2px #911813" : "solid 2px #003049",
            justifyContent: "center",
            padding: "3px",
            cursor: "pointer"
          }}
            onClick={() => setStatusContact("")}
          >
            Ul.Act
          </ItemAux>
          <ItemAux style={{
            color: 'black',
            borderRadius: "8px",
            border: statusContact === "No Contactado" ? "solid 2px #911813" : "solid 2px #003049",
            justifyContent: "center",
            padding: "3px",
            cursor: "pointer"
          }}
            onClick={() => setStatusContact("No Contactado")}
          >
            Pendientes
          </ItemAux>
          <ItemAux style={{
            color: 'black',
            borderRadius: "8px",
            border: statusContact === "Contactado" ? "solid 2px #911813" : "solid 2px #003049",
            justifyContent: "center",
            padding: "3px",
            cursor: "pointer"
          }}
            onClick={() => setStatusContact("Contactado")}
          >
            Contactados
          </ItemAux>
          <ItemAux style={{
            color: 'black',
            borderRadius: "8px",
            border: statusContact === "Sin Respuesta" ? "solid 2px #911813" : "solid 2px #003049",
            justifyContent: "center",
            padding: "3px",
            cursor: "pointer"
          }}
            onClick={() => setStatusContact("Sin Respuesta")}
          >
            Sin RTA
          </ItemAux>
        </DivRow1>
        <Input
          type="text"
          placeholder="Buscar..."
          value={buscador}
          onChange={handleChangeBuscador}
        />
        <ScrollContainer ref={scrollContainerRef} >
          {contacts && contacts.length > 0 && !buscador ?
            (
              <>
                {contacts.map((contact, index) => (
                  <CardContacto
                    key={index}
                    contact={contact}
                    handlerOpenModalObservaciones={handlerOpenModalObservaciones}
                    handlerOpenModal={handlerOpenModal}
                    formData={formData}
                    setFormData={setFormData}
                    setSelectContact={setSelectContact}
                    selectedContact={selectedContact}
                    setIdContact={setIdContact}

                  />
                ))}
              </>
            ) : (
              <>
                {!buscador ?

                  <Text style={{ textAlign: 'center' }}>No se encontraron resultados.</Text> : null
                }
              </>
            )
          }
          {buscador && contactsFilter && contactsFilter.length > 0 ?
            (
              <>
                {contactsFilter.map((contact, index) => (
                  <CardContacto
                    key={index}
                    contact={contact}
                    handlerOpenModalObservaciones={handlerOpenModalObservaciones}
                    handlerOpenModal={handlerOpenModal}
                    formData={formData}
                    setFormData={setFormData}
                    setSelectContact={setSelectContact}
                    selectedContact={selectedContact}
                    setIdContact={setIdContact}
                  />
                ))}
              </>
            ) : (
              <>
                {buscador ?

                  <Text style={{ textAlign: 'center' }}>No se encontraron resultados.</Text> : null
                }
              </>
            )
          }
        </ScrollContainer>
      </DivContentFilters>
      <DivFlexColumn params={params} >
        {
          openAddContact ?
            <AgregarContacto
              openAddContact={openAddContact}
              setOpenAddContact={setOpenAddContact}
              userId={user.id}
              setRefresh={setRefresh}
            />
            : null
        }
        {
          loading === false && selectedContact?.id !== undefined ? (
            <DetailContact
              selectedContact={selectedContact}
              formData={formData}
              handlerOpenModal={handlerOpenModal}
              handlerOpenModalObservaciones={handlerOpenModalObservaciones}
              openModalObservaciones={openModalObservaciones}
              openModal={openModal}
              statusContact={statusContact}
              closeModalObservaciones={closeModalObservaciones}
              closeModal={closeModal}
              setSeActualizoContacto={setSeActualizoContacto}
              getContacts={getContacts}
              getContactID={getContactID}
              scrollContainerRef={scrollContainerRef}
              setContacts={setContacts}
              user={user}
            />
          ) : loading === false && !selectedContact?.id ? (
            <DivBoxContainer>
              <VideoCont muted autoPlay loop src={test} />
            </DivBoxContainer>
          ) : (
            <CustomCircularProgress size={50} padding='15vw' />
          )
        }
      </DivFlexColumn>
    </ContainerBox>

  );
};


export default Contacts;